import { Icon, IconProps } from "@chakra-ui/react";

export function CaretLeftIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3536 7.64645C14.5488 7.84171 14.5488 8.15829 14.3536 8.35355L10.7071 12L14.3536 15.6464C14.5488 15.8417 14.5488 16.1583 14.3536 16.3536C14.1583 16.5488 13.8417 16.5488 13.6464 16.3536L9.64645 12.3536C9.45118 12.1583 9.45118 11.8417 9.64645 11.6464L13.6464 7.64645C13.8417 7.45118 14.1583 7.45118 14.3536 7.64645Z"
        fill="currentColor"
      />
    </Icon>
  );
}
